import type { AppBannerPropsType } from '@beef/smart-kit';

export const enum LayoutType {
  Vip = 'vip',
  Young = 'young',
  Yandex = 'yandex',
  Digital = 'digital',
  ZTariff = 'ztariff',
  Default = 'default',
  TariffLive = 'tariffLive',
  Constructor = 'constructor',
  BaseConstructor = 'baseConstructor',
  TariffConstructor = 'tariffConstructor',
  UnitedConstructor = 'unitedConstructor',
}

export interface ICharacter {
  activeColor: string;
  imageSrc: string;
  name: string;
  optionSoc: string;
  power: string;
  type: number;
}

export interface ITariffLayoutData {
  bannerInfo: {
    benefits: Array<string>;
    image: string;
  };
  charactersData: {
    activeOptionSoc: string;
    characters: Array<ICharacter>;
    onClick: () => void;
    title: string;
  };
  checkData?: Record<string, unknown>;
  checkInfo?: unknown;
  content: {
    commonAppBanner: AppBannerPropsType;
    subscription?: Record<string, unknown>;
  };
  convergenceContent?: Record<string, unknown>;
  defaultInfo?: Record<string, unknown>;
  familyData?: unknown;
  hasDpcSubscriptionFeeOnly?: boolean;
  hasSpecialOffer?: boolean;
  hasTariffConstructor: boolean;
  hasZTariff: boolean;
  homeInternet?: Record<string, unknown>;
  isAnimalsTariffLayout: boolean;
  isAvailable: boolean;
  isConnectedCharacter: boolean;
  isDataTariffLayout: boolean;
  packages: Array<Record<'unit' | 'value', string>>;
  presetDiscounts: {
    changeTariffForm: number;
    mnpForm: number;
    simOrderForm: number;
  };
  prices: Array<{
    label: string;
    legal: {
      text: string;
      type: string;
    };
    value: number;
  }>;
  slides: Array<Record<string, unknown>>;
  socBaseConnected: string;
  specialOfferInfo?: Record<string, unknown>;
  subscription?: {
    icon: string;
    label: string;
    unit: string;
    value: string;
  };
  tariffOptions?: Array<unknown>;
}
export interface ITariffCardReactModel {
  data: {
    alias: string;
    availableForConnect: boolean;
    availableInShop: boolean;
    banners: Array<unknown>;
    baseUrl?: string;
    benefits: Array<Record<string, unknown>>;
    connectButton: string;
    descriptions: Array<unknown>;
    discountValue?: number;
    discountedPrice: unknown;
    esim: {
      [key: string]: unknown;
      popupUrl: string;
      text: string;
    };
    familyNavigation?: Array<unknown>;
    feeNote?: {
      text: string;
      toolTip: string;
    };
    fullDescriptionLink: {
      format: string;
      href: string;
      size: string;
      text: string;
    };
    guide?: Array<unknown>;
    isArchived: boolean;
    isAuthenticated: boolean;
    isConnected: boolean;
    isOrderBtnsRow?: boolean;
    layoutData: ITariffLayoutData;
    layoutType: LayoutType;
    marketCode: string;
    mnpWidget: unknown;
    pageSubtitle?: string;
    pageTitle: string;
    pageTitleIcon: string;
    price: Record<'unit' | 'value', string>;
    productTypeTitle?: {
      discount: string;
      text: string;
    };
    rcRate: unknown;
    rcRateWithoutDiscount: unknown;
    simDiscount?: {
      deliveryOnly: boolean;
      label: string;
      percent: number;
    };
    soc: string;
    twoOrderBtnsData?: {
      [key: string]: unknown;
      connectBtnText: string;
    };
  };
}
